import { render, staticRenderFns } from "./myHead.vue?vue&type=template&id=09c3c9ab&scoped=true&"
import script from "./myHead.vue?vue&type=script&lang=js&"
export * from "./myHead.vue?vue&type=script&lang=js&"
import style0 from "./myHead.vue?vue&type=style&index=0&id=09c3c9ab&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3c9ab",
  null
  
)

export default component.exports